import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { ProfitAndLossPage } from '../../features/reports/profit-and-loss-page'
import { profitAndLossSearchSchema } from '../../features/reports/search'

export const Route = createFileRoute('/_app/profit-and-loss')({
  staticData: { crumb: 'profitAndLoss' },
  validateSearch: profitAndLossSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'reports.financial'),
  component: ProfitAndLossPage,
})
